<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const canAddUnits = computed(() => store.getters.hasPermission('inventory.add'));
const canEditUnits = computed(() => store.getters.hasPermission('inventory.edit'));
const canDeleteUnits = computed(() => store.getters.hasPermission('inventory.delete'));
</script>

<template>
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageaddheader :title="title" :title1="title1" :items="canAddUnits ? items : []" />

        <div class="card">
          <div class="card-body">
            <div class="table-top">
              <div class="search-set">
                <div class="search-path">
                  <a
                    class="btn btn-filter"
                    id="filter_search"
                    v-on:click="filter = !filter; this.search=''"
                    :class="{ setclose: filter }"
                  >
                    <img src="../../../assets/img/icons/filter.svg" alt="img" />
                    <span><img src="../../../assets/img/icons/closes.svg" alt="img" /></span>
                  </a>
                </div>
                <div class="search-input">
                  <a class="btn btn-searchset">
                    <img src="../../../assets/img/icons/search-white.svg" alt="img" />
                  </a>
                  <div id="DataTables_Table_0_filter" class="dataTables_filter">
                    <label>
                      <input
                        type="search"
                        v-model="search"
                        class="form-control form-control-sm"
                        placeholder="Search..."
                        aria-controls="DataTables_Table_0"
                        @change="searching"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <a-table :columns="columns" :data-source="filteredItems">
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'unitid'">
                    <div class="productimgname">
                      <a href="javascript:void(0);">{{ record.unitname }}</a>
                    </div>
                  </template>
                  <template v-else-if="column.key === 'action' && (canEditUnits || canDeleteUnits)">
                    <a v-if="canEditUnits" class="me-3" @click="editunit(record)" href="javascript:void(0);">
                      <img src="../../../assets/img/icons/edit.svg" alt="img" />
                    </a>
                    <a
                      v-if="canDeleteUnits"
                      class="me-3 confirm-text"
                      href="javascript:void(0);"
                      @click="showAlert(record.unitid)"
                    >
                      <img src="../../../assets/img/icons/delete.svg" alt="img" />
                    </a>
                  </template>
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

const columns = [
  { sorter: true },
  {
    title: "Unit Name",
    dataIndex: "unitname",
    key: "unitid",
    sorter: {
      compare: (a, b) => (a.unitname || "").localeCompare(b.unitname || ""),
    },
  },
  {
    title: "Unit Code",
    dataIndex: "unitcode",
    sorter: (a, b) => (a.unitcode || "").localeCompare(b.unitcode || ""),
  },
  {
    title: "Location",
    dataIndex: "locationname",
    sorter: (a, b) => (a.locationname || "").localeCompare(b.locationname || ""),
  },
  {
    title: "Description",
    dataIndex: "description",
    sorter: (a, b) => (a.description || "").localeCompare(b.description || ""),
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];

export default {
  data() {
    return {
      filter: false,
      search: "",
      title: "Unit list",
      title1: "View/Search item units",
      items: [
        {
          text: "Add Unit",
          addname: "/addunit",
        },
      ],
      data: null,
      columns,
    };
  },
  methods: {
    searching() {
      if (this.search) this.filter = true;
    },
    showAlert(id) {
      if (!this.$store.getters.hasPermission('inventory.delete')) {
        return;
      }
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonColor: "#FF9F43",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (!result.isConfirmed) return;
        axios
          .delete("/v1/units/" + id)
          .then(() => {
            Swal.fire("Deleted!", "Unit has been deleted.");
            const index = this.data.findIndex((o) => o.unitid === id);
            if (index !== -1) this.data.splice(index, 1);
          })
          .catch((error) => {
            console.log(error);
            Swal.fire(error.response?.data?.detail || "Could not delete unit");
          });
      });
    },
    editunit(unit) {
      if (!this.$store.getters.hasPermission('inventory.edit')) {
        return;
      }
      this.$router.push({ path: "/editunit", query: { id: unit.unitid } });
    },
    async getUnits() {
      axios
        .get("/v1/units")
        .then((response) => {
          this.data = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        });
    },
  },
  computed: {
    filteredItems() {
      return this.data
        ? this.data.filter((item) => {
            const term = this.search.toLowerCase();
            return (
              !this.search ||
              item.unitname.toString().toLowerCase().includes(term) ||
              (item.unitcode || "").toString().toLowerCase().includes(term) ||
              (item.locationname || "").toString().toLowerCase().includes(term)
            );
          })
        : null;
    },
  },
  beforeMount() {
    this.getUnits();
  },
  name: "unitlist",
};
</script>

<style>
.ant-tooltip {
  display: none !important;
}
</style>
